import React, { useRef, useEffect } from "react";
import "./notificationPopup.css"; // Assuming you have a CSS file for styles

const NotificationPopup = ({ visible, notifications, loadMoreNotifications, markVisibleRead }) => {
  const notificationContainerRef = useRef(null);

  const isElementInView = (container, element) => {
    if (!container || !element) return false;
    const containerTop = container.scrollTop;
    const containerBottom = containerTop + container.clientHeight;

    const elemTop = element.offsetTop;
    const elemBottom = elemTop + element.clientHeight;

    return elemBottom >= containerTop && elemTop <= containerBottom;
  };

  const handleScroll = () => {
    if (!notificationContainerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = notificationContainerRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      loadMoreNotifications();
    }

    const container = notificationContainerRef.current;
    const unreadVisibleIds = [];

    notifications.forEach((notif) => {
      const elem = document.getElementById(`notif-${notif._id}`);
      if (elem && !notif.is_read && isElementInView(container, elem)) {
        unreadVisibleIds.push(notif._id);
      }
    });

    if (unreadVisibleIds.length > 0) {
      markVisibleRead(unreadVisibleIds);
    }
  };

  useEffect(() => {
    if (visible && notificationContainerRef.current) {
      handleScroll();
    }
  }, [visible, notifications]);

  return (
    <>
      {visible && (
        <div
          ref={notificationContainerRef}
          onScroll={handleScroll}
          className="popup notification-popup"
          style={{
            maxHeight: 350,
            width: 350,
            overflowY: "auto",
            padding: 12,
            backgroundColor: "rgba(30, 30, 30, 0.95)",
            boxShadow: "0 10px 20px rgba(0,0,0,0.4)",
            borderRadius: 12,
            color: "#f9f9f9",
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            userSelect: "none",
          }}
        >
          <p
            style={{
              fontWeight: "700",
              marginBottom: 12,
              fontSize: 18,
              borderBottom: "1px solid #444",
              paddingBottom: 8,
            }}
          >
            Notifications
          </p>
          <ul style={{ paddingLeft: 0, listStyle: "none", margin: 0 }}>
            {notifications.length > 0 ? (
              notifications.map((notif) => (
                <li
                  key={notif._id}
                  id={`notif-${notif._id}`}
                  style={{
                    padding: "12px 15px",
                    marginBottom: 10,
                    borderRadius: 8,
                    backgroundColor: notif.is_read ? "rgba(255,255,255,0.05)" : "rgba(255, 255, 255, 0.12)",
                    boxShadow: notif.is_read
                      ? "none"
                      : "0 0 8px rgba(32, 132, 222, 0.5)",
                    cursor: notif.is_read ? "default" : "pointer",
                    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (!notif.is_read) {
                      e.currentTarget.style.backgroundColor = "rgba(32, 132, 222, 0.15)";
                      e.currentTarget.style.boxShadow = "0 0 10px rgba(32, 132, 222, 0.75)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = notif.is_read
                      ? "rgba(255,255,255,0.05)"
                      : "rgba(255, 255, 255, 0.12)";
                    e.currentTarget.style.boxShadow = notif.is_read
                      ? "none"
                      : "0 0 8px rgba(32, 132, 222, 0.5)";
                  }}
                >
                  <h4
                    style={{
                      margin: 0,
                      fontSize: 15,
                      fontWeight: 600,
                      color: notif.is_read ? "#bbb" : "#20a4f3",
                      textTransform: "capitalize",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={notif.type}
                  >
                    {notif.type}
                  </h4>
                  <p
                    style={{
                      margin: "6px 0 0",
                      fontSize: 14,
                      color: "#e1e1e1",
                      lineHeight: 1.3,
                      maxHeight: 40,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={notif.message}
                  >
                    {notif.message}
                  </p>
                </li>
              ))
            ) : (
              <li
                style={{
                  color: "#888",
                  textAlign: "center",
                  padding: 20,
                  fontStyle: "italic",
                }}
              >
                No new notifications
              </li>
            )}
          </ul>
        </div>
      )}
    </>
  );
};

export default NotificationPopup;
